import FeatureInfo from './FeatureInfo';

export default FeatureInfo;